// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Video Player Styles */
.video-player-container {
  background-color: #0a0a0a;
  min-height: 100vh;
  color: #ffffff;
}

.video-wrapper {
  position: relative;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
}

/* Video Controls */
.video-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
  padding: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-wrapper:hover .video-controls {
  opacity: 1;
}

.video-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}

.video-progress-filled {
  height: 100%;
  background-color: #FFEB3B;
  transition: width 0.1s linear;
}

/* Comment Styles */
.comment-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.comment-item:last-child {
  border-bottom: none;
}

.comment-author {
  cursor: pointer;
  transition: color 0.2s ease;
}

.comment-author:hover {
  color: #FFEB3B;
}

.comment-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.comment-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}

/* Related Videos */
.related-video-item {
  display: flex;
  gap: 12px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.related-video-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.related-video-thumbnail {
  width: 120px;
  height: 68px;
  object-fit: cover;
  border-radius: 4px;
}

.related-video-info {
  flex: 1;
  min-width: 0;
}

.related-video-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.related-video-author {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2px;
}

.related-video-stats {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* Action Buttons */
.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.action-button.liked {
  background-color: #FFEB3B;
  color: #000000;
  border-color: #FFEB3B;
}

/* Loading State */
.loading-skeleton {
  background: linear-gradient(90deg, #1a1a1a 25%, #2a2a2a 50%, #1a1a1a 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .video-controls {
    opacity: 1;
  }
  
  .related-videos-section {
    margin-top: 24px;
  }
  
  .related-video-item {
    padding: 4px;
  }
  
  .action-buttons {
    flex-wrap: wrap;
    gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/VideoPlayer/VideoPlayer.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4DAA4D;EAC5D,aAAa;EACb,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF","sourcesContent":["/* Video Player Styles */\n.video-player-container {\n  background-color: #0a0a0a;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n.video-wrapper {\n  position: relative;\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.video-element {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  cursor: pointer;\n}\n\n/* Video Controls */\n.video-controls {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));\n  padding: 16px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.video-wrapper:hover .video-controls {\n  opacity: 1;\n}\n\n.video-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: rgba(255, 255, 255, 0.2);\n  cursor: pointer;\n}\n\n.video-progress-filled {\n  height: 100%;\n  background-color: #FFEB3B;\n  transition: width 0.1s linear;\n}\n\n/* Comment Styles */\n.comment-item {\n  display: flex;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.comment-item:last-child {\n  border-bottom: none;\n}\n\n.comment-author {\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.comment-author:hover {\n  color: #FFEB3B;\n}\n\n.comment-text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.comment-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n/* Related Videos */\n.related-video-item {\n  display: flex;\n  gap: 12px;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.related-video-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.related-video-thumbnail {\n  width: 120px;\n  height: 68px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.related-video-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.related-video-title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.related-video-author {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 2px;\n}\n\n.related-video-stats {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Action Buttons */\n.action-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: transparent;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.action-button.liked {\n  background-color: #FFEB3B;\n  color: #000000;\n  border-color: #FFEB3B;\n}\n\n/* Loading State */\n.loading-skeleton {\n  background: linear-gradient(90deg, #1a1a1a 25%, #2a2a2a 50%, #1a1a1a 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n  border-radius: 4px;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .video-controls {\n    opacity: 1;\n  }\n  \n  .related-videos-section {\n    margin-top: 24px;\n  }\n  \n  .related-video-item {\n    padding: 4px;\n  }\n  \n  .action-buttons {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
